import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=1d4f9925&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d4f9925')) {
      api.createRecord('1d4f9925', component.options)
    } else {
      api.reload('1d4f9925', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=1d4f9925&", function () {
      api.rerender('1d4f9925', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QICPjRtoylWi/JS/videoIframe.vue"
export default component.exports